import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/personal-calendar.svg'


const _withScopeId = n => (_pushScopeId("data-v-2994794c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-w-full" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-8 tw-w-full" }
const _hoisted_3 = { class: "form__wrapper tw-w-full md:!tw-h-full" }
const _hoisted_4 = { class: "modal_input_wrapper !tw-m-0 tw-flex tw-flex-col tw-w-full tw-gap-4" }
const _hoisted_5 = { class: "modal_input !tw-m-0 tw-gap-1 tw-flex tw-flex-col" }
const _hoisted_6 = { class: "custom_dropdown" }
const _hoisted_7 = { class: "modal_input_start !tw-m-0 tw-gap-1 tw-flex tw-flex-col w-full" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "£", -1))
const _hoisted_9 = { class: "modal_input !tw-m-0 tw-gap-1 tw-flex tw-flex-col w-full" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tw-cursor-pointer",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "modal_input !tw-m-0 tw-gap-0 tw-flex tw-flex-col w-full" }
const _hoisted_13 = { class: "tw-mt-2 tw-mb-4 tw-w-full tw-h-auto tw-flex tw-flex-col tw-gap-4 tw-p-3 tw-box-border tw-border-[1px] tw-border-[#DFDFDF] tw-border-solid tw-rounded-[8px] tw-bg-[#F8FBFD]" }
const _hoisted_14 = { class: "upload__section md:!tw-h-[100px]" }
const _hoisted_15 = { class: "uploade-wrapper custom-file-upload !tw-h-[97px] md:!tw-h-full !tw-w-full !tw-mt-4 !tw-rounded-lg tw-border-[rgba(0,0,0,0.4)] tw-border-[1px] tw-border-dashed !tw-mb-4" }
const _hoisted_16 = { class: "attachment-list !tw-mt-0" }
const _hoisted_17 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_18 = {
  key: 0,
  class: "w-full sm:w-80"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  Uploading file...", -1))
const _hoisted_20 = { class: "tw-w-full tw-flex tw-gap-3 tw-items-center tw-justify-end tw-pt-4 tw-border-t-dashed-custom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_PdfIcon = _resolveComponent("PdfIcon")!
  const _component_ImageIcon = _resolveComponent("ImageIcon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, {
    onOnClose: $setup.onClickBackButton,
    maxWidth: "100%",
    headerTitle: $setup.isEditMode ? 'Edit Insurance' : 'Add Insurance',
    headerDescription: "Please enter your qualification details; note that proof will be required before engaging in any projects on iKnowa.",
    width: "570px",
    isTitleStrong: false,
    paddingLarge: false
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_form, {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
              rules: $setup.validation,
              ref: "insuranceFormRef",
              class: "tw-gap-4 tw-w-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_Text, {
                      variant: "span",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Insurance Type")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_select, {
                        items: $setup.insurancesList,
                        "item-title": "name",
                        "item-value": "id",
                        modelValue: $setup.insuranceForm.type,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.insuranceForm.type) = $event)),
                        class: "custom_selector",
                        density: "compact",
                        placeholder: "e.g Plumbing & Heating",
                        "center-affix": true,
                        "single-line": true,
                        "menu-props": { contentClass: 'text__selector' },
                        variant: "outlined"
                      }, null, 8, ["items", "modelValue"]),
                      ($setup.insuranceForm.type === $setup.getOthersId)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 0,
                            density: "compact",
                            rules: $setup.validation.typeText,
                            placeholder: "E.g. Public liability",
                            variant: "outlined",
                            modelValue: $setup.customType,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customType) = $event)),
                            class: "c-input rounded-full sm:mt-4 mt-2 mb-2 w-full sm:w-80"
                          }, null, 8, ["rules", "modelValue"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Text, {
                      variant: "span",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Coverage £")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_text_field, {
                      class: "input_field",
                      density: "compact",
                      rules: $setup.validation.coverage,
                      modelValue: $setup.formattedCoverage,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formattedCoverage) = $event)),
                      variant: "outlined",
                      placeholder: "E.g. £5,000,000",
                      onBlur: $setup.formatCoverage
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["rules", "modelValue", "onBlur"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Text, {
                      variant: "span",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Expiry date")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DatePicker, {
                      class: "date_wrapper",
                      modelValue: $setup.insuranceForm.expiryDate,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.insuranceForm.expiryDate) = $event)),
                      popover: true,
                      "min-date": $setup.todayDate
                    }, {
                      default: _withCtx(({ togglePopover, inputValue }) => [
                        _createElementVNode("div", {
                          class: "calendar__select",
                          onClick: () => togglePopover()
                        }, [
                          _createVNode(_component_v_text_field, {
                            value: inputValue,
                            variant: "outlined",
                            placeholder: "Choose Date",
                            class: "input_field",
                            color: "#0C0F4A"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        ], 8, _hoisted_10)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Text, {
                      variant: "span",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Documents*")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_v_file_input, {
                            class: _normalizeClass(["upload_file !tw-mb-0 !tw-bg-white", {
                            'added-img':
                              $setup.insuranceForm.attachments &&
                              $setup.insuranceForm.attachments?.length,
                          }]),
                            label: "Upload images & files, or Browse",
                            variant: "solo-filled",
                            modelValue: $setup.insuranceForm.attachments,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.insuranceForm.attachments) = $event)),
                            rules: $setup.validation.attachments,
                            onChange: $setup.onFileChange,
                            "prepend-icon": "mdi-file-image-box"
                          }, null, 8, ["modelValue", "rules", "class", "onChange"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.insuranceForm.attachments, (file, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "attachment-item !tw-bg-none !tw-p-0 !tw-border-none"
                          }, [
                            _createElementVNode("div", _hoisted_17, [
                              (file.mime === 'application/pdf')
                                ? (_openBlock(), _createBlock(_component_PdfIcon, {
                                    key: 0,
                                    class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                  }))
                                : (_openBlock(), _createBlock(_component_ImageIcon, {
                                    key: 1,
                                    class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                  })),
                              _createVNode(_component_Text, {
                                variant: "p",
                                textWeight: "400"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(file.originalName), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createVNode(_component_v_icon, {
                              class: "cursor-pointer !tw-text-[16px]",
                              icon: "mdi-close",
                              onClick: $setup.removeAttachmentFile
                            }, null, 8, ["onClick"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    ($setup.isFileUploading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_v_progress_linear, {
                            "model-value": $setup.uploadProgress,
                            height: 10,
                            width: 5,
                            striped: "",
                            rounded: "",
                            color: "#0C0F4A"
                          }, null, 8, ["model-value"]),
                          _createTextVNode(" " + _toDisplayString($setup.uploadProgress) + " %", 1),
                          _hoisted_19
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["rules"])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_Button, {
          variant: "secondary",
          label: "Cancel",
          isCapitalize: true,
          onClick: $setup.onClickBackButton,
          disabled: $setup.isInsuranceFormSubmit,
          class: "!tw-w-auto"
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          variant: "accent",
          label: $setup.isEditMode ? 'Update' : 'Save',
          isCapitalize: true,
          isLoading: $setup.isInsuranceFormSubmit,
          disabled: $setup.isSaveButtonDisable,
          onClick: $setup.onClickInsuranceNext,
          class: "!tw-w-auto"
        }, null, 8, ["label", "isLoading", "disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose", "headerTitle"]))
}